export const ALL_GAMES = { value: 'all', labelKey: 'All Games' }
export const LIVE_GAMES = { value: 'live', labelKey: 'Live Only' }
export const UPCOMING_GAMES = { value: 'upcoming', labelKey: 'Upcoming' }
export const FINISHED_GAMES = { value: 'finished', labelKey: 'Finished' }

export const STATUS_FILTERS = [
  ALL_GAMES,
  LIVE_GAMES,
  UPCOMING_GAMES,
  FINISHED_GAMES
];

export const DEFAULT_SEASONS = [2025, 2024, 2023];
export const DEFAULT_LEAGUE = 'standard';
export const DEFAULT_TIMEZONE = 'America/New_York';
